import * as tslib_1 from "tslib";
import { UserIdleService } from "angular-user-idle";
import { EnvironmentService } from "../environment/environment.service";
import { NgZone } from '@angular/core';
import { merge, fromEvent } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../environment/environment.service";
var ItauUserIdleService = /** @class */ (function (_super) {
    tslib_1.__extends(ItauUserIdleService, _super);
    function ItauUserIdleService(environmentService, _ngZone) {
        var _this = _super.call(this, {
            idle: environmentService.envModel.itauUserIdleSettings.idle,
            timeout: environmentService.envModel.itauUserIdleSettings.timeout,
            ping: environmentService.envModel.itauUserIdleSettings.ping
        }, _ngZone) || this;
        _this.environmentService = environmentService;
        _super.prototype.setCustomActivityEvents.call(_this, merge(fromEvent(window, 'mousemove'), fromEvent(window, 'mouseclick'), fromEvent(window, 'dblclick'), fromEvent(window, 'wheel'), fromEvent(window, 'resize'), fromEvent(document, 'keydown'), fromEvent(document, 'touchstart'), fromEvent(document, 'touchend')));
        return _this;
    }
    ItauUserIdleService.prototype.getRedirectUri = function () {
        return this.environmentService.envModel.redirectUri;
    };
    ItauUserIdleService.ngInjectableDef = i0.defineInjectable({ factory: function ItauUserIdleService_Factory() { return new ItauUserIdleService(i0.inject(i1.EnvironmentService), i0.inject(i0.NgZone)); }, token: ItauUserIdleService, providedIn: "root" });
    return ItauUserIdleService;
}(UserIdleService));
export { ItauUserIdleService };
